import React, { useState } from "react";
import { Checkbox, Col, Modal, Row } from "antd";
import { CheckboxChangeEvent } from "antd/es/checkbox";
interface PropsType {
  visible: boolean;
  update: Function;
  setInvisible: Function;
  checked: string[];
}

export const ColumnSelect: React.FC<PropsType> = ({
  visible,
  update,
  setInvisible,
  checked,
}) => {
  const [checkedFields, setCheckedFields] = useState(checked);
  const isChecked = (type: string): boolean => {
    return checkedFields.includes(type);
  };
  const handlerOk = async () => {
    update(checkedFields);
    setInvisible();
  };
  const handlerCancel = () => {
    setInvisible();
  };
  const onChange = (e: CheckboxChangeEvent) => {
    let is: boolean = e.target.checked;
    let value: string = e.target.value;
    let _cfs = [...checkedFields];
    if (!is) {
      if (_cfs.includes(value)) _cfs.splice(_cfs.indexOf(value), 1);
    } else {
      if (!_cfs.includes(value)) _cfs.push(value);
    }
    setCheckedFields(_cfs);
  };

  return (
    <>
      <Modal
        title="选择可显示的列"
        open={visible}
        onOk={handlerOk}
        onCancel={handlerCancel}
        okText="保存"
        cancelText="取消"
        width="60vw"
      >
        <>
          <Row>
            <Col span={8}>
              <Checkbox
                value="id"
                checked={isChecked("id")}
                onChange={onChange}
              >
                编号
              </Checkbox>
            </Col>
            <Col span={8}>
              <Checkbox
                value="status"
                checked={isChecked("status")}
                onChange={onChange}
              >
                处理状态
              </Checkbox>
            </Col>
            <Col span={8}>
              <Checkbox
                value="type"
                checked={isChecked("type")}
                onChange={onChange}
              >
                受检人类别
              </Checkbox>
            </Col>
          </Row>
          <Row>
            <Col span={8}>
              <Checkbox
                value="name"
                checked={isChecked("name")}
                onChange={onChange}
              >
                姓名
              </Checkbox>
            </Col>

            <Col span={8}>
              <Checkbox
                value="cat"
                checked={isChecked("cat")}
                onChange={onChange}
              >
                CAT检测
              </Checkbox>
            </Col>
          </Row>
          <Row>
            <Col span={8}>
              <Checkbox
                value="result"
                checked={isChecked("result")}
                onChange={onChange}
              >
                评估结果
              </Checkbox>
            </Col>
          </Row>
          <Row>
            <Col span={8}>
              <Checkbox
                value="code"
                checked={isChecked("code")}
                onChange={onChange}
              >
                受检人编号
              </Checkbox>
            </Col>
            <Col span={8}>
              <Checkbox
                value="hospitalName"
                checked={isChecked("hospitalName")}
                onChange={onChange}
              >
                医院
              </Checkbox>
            </Col>
          </Row>
          <Row>
            <Col span={8}>
              <Checkbox
                value="schoolName"
                checked={isChecked("schoolName")}
                onChange={onChange}
              >
                学校
              </Checkbox>
            </Col>
            <Col span={8}>
              <Checkbox
                value="gradeName"
                checked={isChecked("gradeName")}
                onChange={onChange}
              >
                年级
              </Checkbox>
            </Col>
          </Row>

          <Row>
            <Col span={8}>
              <Checkbox
                value="className"
                checked={isChecked("className")}
                onChange={onChange}
              >
                班级
              </Checkbox>
            </Col>
          </Row>
          <Row>
            <Col span={8}>
              <Checkbox
                value="age"
                checked={isChecked("age")}
                onChange={onChange}
              >
                年龄
              </Checkbox>
            </Col>

            <Col span={8}>
              <Checkbox
                value="sex"
                checked={isChecked("sex")}
                onChange={onChange}
              >
                性别
              </Checkbox>
            </Col>
            <Col span={8}>
              <Checkbox
                value="phoneNo"
                checked={isChecked("phoneNo")}
                onChange={onChange}
              >
                电话
              </Checkbox>
            </Col>
          </Row>
          <Row>
            <Col span={8}>
              <Checkbox
                value="InitName"
                checked={isChecked("InitName")}
                onChange={onChange}
              >
                创建人
              </Checkbox>
            </Col>
            <Col span={8}>
              <Checkbox
                value="InitDate"
                checked={isChecked("InitDate")}
                onChange={onChange}
              >
                创建时间
              </Checkbox>
            </Col>
            <Col span={8}>
              <Checkbox
                value="fillinName"
                checked={isChecked("fillinName")}
                onChange={onChange}
              >
                填报人
              </Checkbox>
            </Col>
          </Row>
          <Row>
            <Col span={8}>
              <Checkbox
                value="fillinDate"
                checked={isChecked("fillinDate")}
                onChange={onChange}
              >
                填报时间
              </Checkbox>
            </Col>
            <Col span={8}>
              <Checkbox
                value="samplingName"
                checked={isChecked("samplingName")}
                onChange={onChange}
              >
                临床检查医生
              </Checkbox>
            </Col>
            <Col span={8}>
              <Checkbox
                value="samplingDate"
                checked={isChecked("samplingDate")}
                onChange={onChange}
              >
                临床检查时间
              </Checkbox>
            </Col>
          </Row>
          <Row>
            <Col span={6}>
              <Checkbox
                value="checkName"
                checked={isChecked("checkName")}
                onChange={onChange}
              >
                检测操作人
              </Checkbox>
            </Col>
            <Col span={6}>
              <Checkbox
                value="checkDate"
                checked={isChecked("checkDate")}
                onChange={onChange}
              >
                检测时间
              </Checkbox>
            </Col>
            <Col span={6}>
              <Checkbox
                value="sender"
                checked={isChecked("sender")}
                onChange={onChange}
              >
                送检者
              </Checkbox>
            </Col>
            <Col span={6}>
              <Checkbox
                value="checker"
                checked={isChecked("checker")}
                onChange={onChange}
              >
                检测医生
              </Checkbox>
            </Col>
          </Row>
          <Row>
            <Col span={8}>
              <Checkbox
                value="a1"
                checked={isChecked("a1")}
                onChange={onChange}
              >
                A1
              </Checkbox>
            </Col>
            <Col span={8}>
              <Checkbox
                value="a2"
                checked={isChecked("a2")}
                onChange={onChange}
              >
                A2
              </Checkbox>
            </Col>
            <Col span={8}>
              <Checkbox
                value="a3"
                checked={isChecked("a3")}
                onChange={onChange}
              >
                A3
              </Checkbox>
            </Col>
          </Row>
          <Row>
            <Col span={8}>
              <Checkbox
                value="a4"
                checked={isChecked("a4")}
                onChange={onChange}
              >
                A4
              </Checkbox>
            </Col>
            <Col span={8}>
              <Checkbox
                value="b1"
                checked={isChecked("b1")}
                onChange={onChange}
              >
                B1
              </Checkbox>
            </Col>
            <Col span={8}>
              <Checkbox
                value="b2"
                checked={isChecked("b2")}
                onChange={onChange}
              >
                B2
              </Checkbox>
            </Col>
          </Row>
          <Row>
            <Col span={8}>
              <Checkbox
                value="b3"
                checked={isChecked("b3")}
                onChange={onChange}
              >
                B3
              </Checkbox>
            </Col>
            <Col span={8}>
              <Checkbox
                value="b4"
                checked={isChecked("b4")}
                onChange={onChange}
              >
                B4
              </Checkbox>
            </Col>
            <Col span={8}>
              <Checkbox
                value="c2"
                checked={isChecked("c2")}
                onChange={onChange}
              >
                C2
              </Checkbox>
            </Col>
          </Row>
          <Row>
            <Col span={8}>
              <Checkbox
                value="c3"
                checked={isChecked("c3")}
                onChange={onChange}
              >
                C3
              </Checkbox>
            </Col>
            <Col span={8}>
              <Checkbox
                value="c4"
                checked={isChecked("c4")}
                onChange={onChange}
              >
                C4
              </Checkbox>
            </Col>
            <Col span={8}>
              <Checkbox
                value="c5"
                checked={isChecked("c5")}
                onChange={onChange}
              >
                C5
              </Checkbox>
            </Col>
          </Row>
        </>
      </Modal>
    </>
  );
};
